import Vue from 'vue'
import { i18n } from '@/plugins/i18n'
import { invertKeyValues } from '@/common/objects'
import { CommissionConditionID, CommissionOperand, CommissionActionType, CommissionTierType, CommissionMetricBase } from '@/constants'

export const actionTypeStr = (type) => {
    const str = invertKeyValues(CommissionActionType)[type]

    return str ? i18n.t(`v2commission.action_types.${str.toLowerCase()}`) : ''
}

export const commissionTierTypeStr = (tier_type) => {
    const str = invertKeyValues(CommissionTierType)[tier_type]

    return str ? i18n.t(`v2commission.tier_types.${str.toLowerCase()}`) : ''
}

export const commissionMetricBaseStr = (base) => {
    const str = invertKeyValues(CommissionMetricBase)[base]

    return str ? i18n.t(`v2commission.metric_base.${str.toLowerCase()}`) : ''
}

export const ruleConditionSentence = (cond) => {
    const idStr = invertKeyValues(CommissionConditionID)[cond.id]
    const transedId = idStr ? i18n.t(`v2commission.condition.ids.${idStr.toLowerCase()}`) : 'undefined'

    const operandStr = invertKeyValues(CommissionOperand)[cond.operand]
    const transedOperand = idStr ? i18n.t(`v2commission.operands.${operandStr.toLowerCase()}`) : 'undefined'

    let vals = cond.values
    if ([CommissionConditionID.AFFILIATE_JOIN_MATCH, CommissionConditionID.CONVERSION_DATE].includes(cond.id)) {
        vals = vals.map(val => Vue.moment(val).format('LL'))
    }

    if (cond.operand === CommissionOperand.START_WITH) {
        return transedId + ' باید با ' + vals + ' شروع شود. '
    }

    if (cond.id === CommissionConditionID.COUPON_CODE_USAGE) {
        return vals[0] == 0 ? 'در خرید از کد تخفیف استفاده نشده باشد' : 'در خرید از کد تخفیف استفاده شده باشد'
    }

    if (cond.id === CommissionConditionID.COUPON_CODE_AVAILABLITY) {
        return 'کد تخفیف استفاده شده در خرید در افیلی تعریف ' + (vals[0] ? 'شده باشد.' : 'نشده باشد.')
    }

    if (cond.operand === CommissionOperand.END_WITH) {
        return transedId + ' باید با ' + vals + ' خاتمه یابد. '
    }

    if (cond.operand === CommissionOperand.BETWEEN) {
        return transedId + ' باید با ' + vals[0] + ' و ' + vals[1] + ' باشد.'
    }

    if (CommissionConditionID.AFFILIATE_JOIN_DURATION_MATCH === cond.id) {
        return transedId + ' باید ' + transedOperand + ' ' + vals + ' روز قبل باشد. '
    }

    return transedId + ' باید ' + transedOperand + ' ' + vals + ' باشد. '
}